import { Injectable } from '@angular/core';
import { TESearchResults } from '@x/common/tracking/event-models/search.events';
import { TrackingService } from '@x/common/tracking/tracking.service';
import { RegionContextService } from '@x/ecommerce-shop/app/core/region/services/region-context.service';
import { IShopProductItem, IShopProductSearchQuery } from '@x/ecommerce/shop-client';
import { tap } from 'rxjs/operators';

export interface IShopProductItemWithSearchContext extends IShopProductItem {
  searchContext: IShopProductItem['searchContext'] & {
    position?: number;
    queryId?: string | null;
  };
}

@Injectable()
export class SearchService {
  constructor(
    private regionContextService: RegionContextService,
    private analyticsService: TrackingService,
  ) {}

  searchProducts$(query: IShopProductSearchQuery) {
    return this.regionContextService.fetchProductSearch(query).pipe(
      tap((r) => {
        this.analyticsService.sendEvent(
          new TESearchResults({ query: query.searchText, result: r }),
        );
      }),
    );
  }
}
